import usePrivateAxios from "@/common/api/usePrivateAxios"
import { Mapper } from "@/common/services/mapper";
import { useQuery } from "@tanstack/react-query";

type UseCompanyNotificationsConfigurationsProps<T> = {
  filters?: {
    companyId?: string;
  }
  mapper?: (data: any) => T,
}

export const useCompanyNotificationsConfigurations = <T,>({
  filters: { companyId } = {},
  mapper = Mapper.default<T>(),
}: UseCompanyNotificationsConfigurationsProps<T>) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['clientCompanyNotificationConfigurations', companyId],
    queryFn: () => privateAxios.get(`/client/company_notification_configurations`, {
      params: {
        'company_id': companyId,
      },
    }),
    select: (data) => mapper(data?.data?.data),
  });
}
